import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "step", "form", "view", "stepIcon", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--bookings--add--dashboard`
    this.send_product_data = { current_user: {}, account: {}, product: {}, user: {} }
    this.current_step = 0
    this.doMainFormHtml()
  }

  changeStep(ev) {
    this.current_step = ev.target.dataset.next
    this.setStep()
  }

  setStep() {
    this.stepTargets.forEach((element, i) => {
      if (element.dataset.step == this.current_step) {
        element.classList.add("active")
        this.stepIconTargets[i].classList.add("md-primary")
      } else {
        element.classList.remove("active")
        this.stepIconTargets[i].classList.remove("md-primary")
      }
    });
  }

  doMainFormHtml() {
    var html = `<div class="row">
                  <div class="col-1"></div>
                  <div class="col-10">
                    <div class="stepper-horiz">
                      <div class="stepper mc-stepper active" data-${this.controllerName}-target="step" data-step="0">
                        <div class="text-center w-100">
                          <span class="material-icons md-primary" data-${this.controllerName}-target="stepIcon">perm_identity</span>
                        </div>
                        <span class="stepper-text">Médico</span>
                      </div>
                      <div class="stepper mc-stepper" data-${this.controllerName}-target="step" data-step="1">
                        <div class="text-center w-100">
                          <span class="material-icons" data-${this.controllerName}-target="stepIcon">contacts</span>
                        </div>
                        <span class="stepper-text">Contatos</span>
                      </div>
                      <div class="stepper mc-stepper" data-${this.controllerName}-target="step" data-step="2">
                        <div class="text-center w-100">
                          <span class="material-icons" data-${this.controllerName}-target="stepIcon">description</span>
                        </div>
                        <span class="stepper-text">Produto</span>
                      </div>
                      <div class="stepper mc-stepper" data-${this.controllerName}-target="step" data-step="3">
                        <div class="text-center w-100">
                          <span class="material-icons" data-${this.controllerName}-target="stepIcon">how_to_reg</span>
                        </div>
                        <span class="stepper-text">Usuário</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row my-3" data-${this.controllerName}-target="form"
                                      data-controller="operations--products--bookings--add--account
                                                       operations--products--bookings--add--contacts
                                                       operations--products--bookings--add--product
                                                       operations--products--bookings--add--user">
                  
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.setStep()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}